import React, { useEffect, useState } from 'react';

import { useLocation } from 'react-router';

import useTranslate from '@core/hooks/useTranslate';
import BuskSidebar from './BuskSidebar';
import WarehouseSidebar from './WarehouseSidebar';
import { CURRENT_ENV } from '@root/core/configs/env';
import SellerSidebar from './SellerSidebar';
import ForwarderSidebar from './ForwarderSidebar';
import SellerApiSidebar from './SellerApiSidebar';
import WarehouseApiSidebar from './WarehouseApiSidebar';

interface Props {
  authenticated: boolean;
  content: JSX.Element;
}

const LayoutCpn = ({ authenticated, content }: Props) => {
  const [t] = useTranslate();
  const location = useLocation();
  const [path, setPath] = useState<string>('');

  useEffect(() => {
    // if (location.pathname !== "/admin/login") {
    //   const pathUrl: any = ADMIN_NAV_MENU.find((item: NavbarMenu) => {
    //     if (location.pathname.indexOf(item.url) === 0) return item.url;
    //   });
    //   setPath(pathUrl?.url);
    // }
  }, [location.pathname]);

  // const reloadPage = ()=> window.location.reload();

  const renderAdminOrStoreHeader = () => {
    const appRole = CURRENT_ENV.APP_ROLE;
    if (!authenticated) {
      return <></>;
    }
    console.log(appRole, 'appROlw');
    switch (appRole) {
      case 'seller-admin':
        return <SellerSidebar path={path} />;
      case 'warehouse-admin':
        return <WarehouseSidebar path={path} />;
      case 'forwarder-admin':
        return <ForwarderSidebar path={path} />;
      case 'seller-api':
        return <SellerApiSidebar path={path} />;
      case 'warehouse-api':
        return <WarehouseApiSidebar path={path} />;
      default:
        return <BuskSidebar path={path} />;
    }
  };

  return renderAdminOrStoreHeader();
};

export default React.memo(LayoutCpn);
